export default {
  install: (app) => {
    app.config.globalProperties.$rootMakeMeCall = function rootMakeMeCall() {
      return this.$root.makeMeCall()
    }
  }
}
